import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import ListFile from "@/shared/model/ListFile";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";


interface Props {
  file?:ListFile
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'FileCardComponent',
  props: {
    file: { default: undefined }
  },
  setup(__props: any) {


const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, "Name", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.file?.name
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, "Beschreibung", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.file?.description
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, "Dateiname", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.file?.fileName
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[3] || (_cache[3] = _createElementVNode("td", null, "Datum", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.file?.date,
                  "value-type": _unref(SogDataLabelValueType).DateTime
                }, null, 8, ["value", "value-type"])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})